export class SlideInElementConditionsInformer {
	constructor(initiator) {
		this.initiator = initiator;
	}

	/**
	 * Consider all the questions that need to be answered to know whether a
	 * slide-in element (of the name that is passed along) can be shown or not.
	 *
	 * @returns {boolean}
	 */

	areConditionsMet() {
		return this.noElementVisible();
	}

	/**
	 * Answer the question: Is no other slide-in element visible at the moment?
	 *
	 * @returns {boolean}
	 */

	noElementVisible() {
		return document.querySelector('.SlideInElement.SlideInElementShown') === null;
	}
}

window.SlideInElementConditionsInformer = SlideInElementConditionsInformer;
